var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoastalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 195,
    height: 195,
    viewBox: "0 0 195 195",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 97.526,
    height: 75.353,
    fill: "#e9f2f0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-775 -5306)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 97.5,
    cy: 97.5,
    r: 97.5,
    transform: "translate(775 5306)",
    fill: "#963839"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(823.737 5361.97)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.163,17.711h4.748a.926.926,0,0,0,.361-1.779L38.779.073a.93.93,0,0,0-.722,0L.565,15.932a.926.926,0,0,0,.361,1.779H5.673V68.593H4.7a.926.926,0,0,0-.926.926v4.909a.926.926,0,0,0,.926.926H95.74a.926.926,0,0,0,.926-.926V69.519a.926.926,0,0,0-.926-.926H93.367V44.079H96.6a.926.926,0,0,0,.785-1.417l-5.943-9.516a.928.928,0,0,0-.786-.435H71.163ZM53.915,48.836h15.4V68.593h-15.4Zm-25.573,0H48.494V68.593H28.342ZM7.526,32.977h2.905v4.491H7.526Zm7.265,4.49H12.284V32.976h2.507Zm4.359,0H16.643V32.976H19.15Zm3.771,0H21V32.976h1.919Zm25.573-6.343H28.342V17.712H48.494Zm3.569,0H50.347V17.712h1.716Zm8.13,6.343H57.687v-4.49h2.507Zm4.359,0H62.046v-4.49h2.507Zm4.757-4.49v4.49H66.405v-4.49Zm-13.476,4.49H53.915v-4.49h1.919Zm-3.771,0H50.347v-4.49h1.716Zm-8.36-4.49h4.791v4.49H43.7Zm-4.359,0h2.507v4.49H39.345Zm-4.359,4.49v-4.49h2.507v4.49Zm-6.643-4.49h4.79v4.491h-4.79ZM26.49,31.125H24.774V17.712H26.49Zm0,6.343H24.774V32.976H26.49ZM7.526,39.32H69.31v7.664H7.526Zm17.247,9.516H26.49V68.593H24.773Zm25.574,0h1.716V68.593H50.347ZM69.31,31.125h-15.4V17.712h15.4ZM38.418,1.932,71.344,15.859H5.493Zm-15.5,29.193H7.526V17.712h15.4ZM7.526,48.836h15.4V68.593H7.526ZM94.814,73.5H5.624V70.445h89.19Zm-3.3-4.909H71.163V44.079H91.514Zm-1.371-34.03,4.786,7.663H71.163V34.563Z",
    transform: "translate(0 0)",
    fill: "#e9f2f0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.2,92.482H61.753a.926.926,0,0,0-.926.926V107.88a.926.926,0,0,0,.926.927H69.2a.927.927,0,0,0,.926-.927V93.408a.926.926,0,0,0-.926-.926m-.926,14.472H62.68V94.334h5.59Z",
    transform: "translate(-27.056 -41.136)",
    fill: "#e9f2f0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.894,92.659h-9.71a.927.927,0,0,0-.926.927v7.93a.926.926,0,0,0,.926.926h9.71a.926.926,0,0,0,.926-.926v-7.93a.926.926,0,0,0-.926-.927m-8.783,1.853h3v6.077h-3Zm7.857,6.078h-3V94.512h3Z",
    transform: "translate(-7.676 -41.215)",
    fill: "#e9f2f0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.948,92.659h-9.709a.927.927,0,0,0-.926.927v7.93a.926.926,0,0,0,.926.926h9.709a.926.926,0,0,0,.926-.926v-7.93a.927.927,0,0,0-.926-.927m-8.783,1.853h3v6.077h-3Zm7.857,6.078h-3V94.512h3Z",
    transform: "translate(-44.619 -41.215)",
    fill: "#e9f2f0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.018,102.442h9.709a.926.926,0,0,0,.926-.926v-7.93a.927.927,0,0,0-.926-.927h-9.709a.927.927,0,0,0-.926.927v7.93a.926.926,0,0,0,.926.926m8.783-1.853h-3V94.512h3Zm-7.857-6.078h3v6.077h-3Z",
    transform: "translate(-60.534 -41.215)",
    fill: "#e9f2f0"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoastalIcon);
export default __webpack_public_path__ + "static/media/CoastalIcon.0115ee51f3828a2b7da1c366f0db366b.svg";
export { ForwardRef as ReactComponent };